
<div class="patient-dashboard-container" [class.consultation-route]="isConsultationRoute">
  <button
    *ngIf="showDashboardHeaderControls"
    type="button"
    class="appointments-toggle-btn"
    (click)="toggleAppointmentsSection()"
    [attr.aria-label]="hideAppointmentsSection ? 'Expand appointments section' : 'Collapse appointments section'"
    [attr.title]="hideAppointmentsSection ? 'Expand appointments' : 'Collapse appointments'">
    Appointments
    <mat-icon>{{ hideAppointmentsSection ? 'keyboard_double_arrow_up' : 'keyboard_double_arrow_down' }}</mat-icon>
  </button>
  <div class="dashboard-wrapper" [class.summary-only]="hideAppointmentsSection" [class.consultation-route]="isConsultationRoute">
    <!-- Left Section: Appointments (25%) -->
    <div class="appointments-section" *ngIf="!hideAppointmentsSection" [@slideInOut]>
      <div class="section-header">
        <h2 class="section-title">Appointments</h2>
        <cva-manual-refresh
          class="appointments-header-refresh"
          [id]="practitionerId"
          [identifier]="appointmentRefreshIdentifier"
          [additionalData]="appointmentRefreshParams"
          (dataFetched)="refreshDashboardAppointments($event)">
        </cva-manual-refresh>
      </div>
      <div class="appointments-content">
        <cva-appointment-list
          [isCompactMode]="true"
          [isDashboardSelectionMode]="false"
          [allowPastTranscriptionView]="true"
          [externalBookingOpen]="isAppointmentBookingOpen"
          (patientSelected)="onAppointmentPatientSelected($event)"
          (bookingPanelStateChange)="onBookingPanelStateChange($event)">
        </cva-appointment-list>
      </div>
    </div>

    <!-- Right Section: Patient Historical Data (75%) -->
    <div class="historical-data-section">
      @if (isAppointmentBookingOpen) {
      <div class="summary-booking-backdrop" tabindex="0" (click)="closeSummaryBookingPanel()">
        <div class="summary-booking-panel" tabindex="0" (click)="$event.stopPropagation()">
          <cva-book-appointment
            (closeBookingSection)="closeSummaryBookingPanel()"
            (appointmentBooked)="onSummaryAppointmentBooked($event)"></cva-book-appointment>
        </div>
      </div>
      }

      <div class="section-header" *ngIf="showDashboardHeaderControls">
        <h2 class="header-title" [class.has-patient-data]="!!patientData">Patient Dashboard</h2>

        <div class="dashboard-user-profile d-md-none">
          <button type="button" mat-icon-button [matMenuTriggerFor]="dashboardUserMenu"
            aria-label="Open user profile menu">
            <mat-icon>person_outline</mat-icon>
          </button>
          <mat-menu #dashboardUserMenu="matMenu" xPosition="before" class="user-menu-collapse">
            <cva-side-nav-user-menu-items></cva-side-nav-user-menu-items>
          </mat-menu>
        </div>

        @if (patientData) {
        <div class="inline-patient-info">
          <div class="patient-details">
            <div class="patient-full-name">{{ getDisplayPatientName() }}</div>
            <div class="patient-meta">
              <span class="meta-chip"><mat-icon>badge</mat-icon>{{ patientData.medicalRecordNumber || patientData.uid }}</span>
              @if (patientData.gender) {
              <span class="meta-chip"><mat-icon>wc</mat-icon>{{ patientData.gender | titlecase }}</span>
              }
              @if (patientData.dateOfBirth) {
              <span class="meta-chip"><mat-icon>cake</mat-icon>{{ patientData.dateOfBirth | date:'MMM d, y' }}</span>
              }
            </div>
          </div>
        </div>
        }

        @if (patientData) {
          <div class="summary-action-buttons">
            <button
              type="button"
              class="summary-action-btn consult-action-btn"
              (click)="startConsultation()"
              aria-label="Start consultation"
              matTooltip="Start Consultation">
              Consultation
            </button>

            <button
              type="button"
              class="summary-action-btn summary-cdm-btn"
              (click)="openCdmModal(cdmDialogTemplate)"
              [disabled]="isCdmPlanLoading || isCdmSourceLoading"
              aria-label="Open Chronic Condition Management"
              matTooltip="Chronic Condition Management">
              CDM
            </button>
          </div>
        }

        <!-- Search (right) -->
        <div class="patient-search-wrapper">
          <div class="search-field">
            <mat-icon class="search-suffix-icon">search</mat-icon>
            <input 
              type="text" 
              class="patient-search-input"
              placeholder="Search patient by Patient ID"
              [(ngModel)]="selectedPatientId"
              (keyup.enter)="onPatientSelected(selectedPatientId)">
          </div>
          <button type="button" class="search-btn-small" (click)="onPatientSelected(selectedPatientId)">Search</button>
        </div>
      </div>
      
      <div class="historical-data-content" [class.has-content]="!errorMessage">
        @if (errorMessage) {
        <div class="error-message">
          <mat-icon>error_outline</mat-icon>
          <div>
            <strong>Unable to load patient</strong>
            <p>{{ errorMessage }}</p>
          </div>
        </div>
        } @else if (patientData) {
        
        <div class="historical-cards-grid">
          <!-- Allergies Card -->
          @if (loadingAllergies) {
            <div class="summary-card allergies-card card--wide skeleton-card">
              <div class="card-inner">
                <div class="card-head">
                  <div class="card-icon-wrap">
                    <mat-icon>warning_amber</mat-icon>
                  </div>
                  <div class="card-title-area">
                    <div class="card-title">Allergies</div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="skeleton-item skeleton-row"></div>
                  <div class="skeleton-item skeleton-row"></div>
                  <div class="skeleton-item skeleton-row"></div>
                </div>
              </div>
            </div>
          } @else if (hasAllergiesError) {
            <div class="summary-card allergies-card card--wide empty-card placeholder-card">
              <div class="card-inner">
                <div class="card-head">
                  <div class="card-icon-wrap">
                    <mat-icon>warning_amber</mat-icon>
                  </div>
                  <div class="card-title-area">
                    <div class="card-title">Allergies</div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="empty-state card-error-state">
                    <p>Failed to load allergies</p>
                    <button type="button" class="card-retry-btn" (click)="retryAllergies()">Retry</button>
                  </div>
                </div>
              </div>
            </div>
          } @else if (allergies.length === 0) {
            <div class="summary-card allergies-card card--wide empty-card placeholder-card">
              <div class="card-inner">
                <div class="card-head">
                  <div class="card-icon-wrap">
                    <mat-icon>warning_amber</mat-icon>
                  </div>
                  <div class="card-title-area">
                    <div class="card-title">Allergies</div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="empty-state">
                    <p>No results found</p>
                  </div>
                </div>
              </div>
            </div>
          } @else {
            <div class="summary-card allergies-card card--wide">
            <div class="card-accent"></div>
            <div class="card-inner">
              <div class="card-head">
                <div class="card-icon-wrap">
                  <mat-icon>warning_amber</mat-icon>
                </div>
                <div class="card-title-area">
                  <div class="card-title">Allergies</div>
                </div>
                <button mat-icon-button class="expand-btn" (click)="openHistoricalDetails('Allergy', 'Allergies')" aria-label="View all allergies">
                  <mat-icon>open_in_full</mat-icon>
                </button>
              </div>
              <div class="card-body">
                <div class="allergy-list">
                  @for (allergy of allergies.slice(0, 5); track allergy.uid) {
                    <div class="allergy-row" tabindex="0" [class.row-active]="activeAllergyUid === allergy.uid" (click)="showAllergyTooltip(allergy, $event)">
                      <span class="allergy-allergen" [title]="allergy.allergen.display || '—'">{{ allergy.allergen.display || '—' }}</span>
                      <span class="allergy-status" [ngClass]="allergy.clinicalStatus.code.toLowerCase()">{{ allergy.clinicalStatus.code || '—' }}</span>
                      <span class="allergy-date">{{ allergy.onsetDate ? (allergy.onsetDate | date:'dd MMM yyyy') : '—' }}</span>
                    </div>
                  }
                  @if (allergies.length > 5) {
                    <span class="allergy-more">+{{ allergies.length - 5 }} more</span>
                  }
                </div>
              </div>
            </div>
            </div>
          }

          <!-- Allergy Details Tooltip -->
          @if (selectedAllergyDetails) {
                 <div class="tooltip-overlay" tabindex="0" (click)="closeAllergyTooltip()">
              <div class="tooltip-content allergy-tooltip" 
                   tabindex="0"
                   [ngStyle]="tooltipNgStyle"
                   (click)="$event.stopPropagation()">
                <div class="tooltip-arrow" 
                     [ngClass]="{'arrow-up': !tooltipPosition.isAbove}"
                   [ngStyle]="{'left': tooltipPosition.arrowLeft + '%'}"></div>
                <div class="tooltip-header">
                  <h4>{{ getAllergyDetailValue('allergen') }}</h4>
                  <button mat-icon-button class="close-btn" (click)="closeAllergyTooltip()">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
                <div class="tooltip-body">
                  <div class="tooltip-field">
                    <span class="tooltip-label">Category:</span>
                    <span class="tooltip-value">{{ getAllergyDetailValue('category') }}</span>
                  </div>
                  <div class="tooltip-field">
                    <span class="tooltip-label">Status:</span>
                    <span class="tooltip-value" [ngClass]="getAllergyStatusClass()">{{ getAllergyDetailValue('status') }}</span>
                  </div>
                  <div class="tooltip-field">
                    <span class="tooltip-label">Type:</span>
                    <span class="tooltip-value">{{ getAllergyDetailValue('type') }}</span>
                  </div>
                  <div class="tooltip-field">
                    <span class="tooltip-label">Criticality:</span>
                    <span class="tooltip-value">{{ getAllergyDetailValue('criticality') }}</span>
                  </div>
                  <div class="tooltip-field">
                    <span class="tooltip-label">Verification:</span>
                    <span class="tooltip-value">{{ getAllergyDetailValue('verification') }}</span>
                  </div>
                  <div class="tooltip-field">
                    <span class="tooltip-label">Onset Date:</span>
                    <span class="tooltip-value">{{ formatTooltipDate(selectedAllergyDetails.onsetDate) }}</span>
                  </div>
                  <div class="tooltip-field">
                    <span class="tooltip-label">Recorded Date:</span>
                    <span class="tooltip-value">{{ formatTooltipDate(selectedAllergyDetails.recordedDate) }}</span>
                  </div>
                  @if (getAllergyDetailValue('reaction') !== '—') {
                    <div class="tooltip-field">
                      <span class="tooltip-label">Reaction:</span>
                      <span class="tooltip-value">{{ getAllergyDetailValue('reaction') }}</span>
                    </div>
                  }
                  @if (getAllergyDetailValue('note') !== '—') {
                    <div class="tooltip-field">
                      <span class="tooltip-label">Note:</span>
                      <span class="tooltip-value">{{ getAllergyDetailValue('note') }}</span>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
          
          <!-- Vitals Card -->
          @if (loadingVitals) {
            <div class="summary-card vitals-card card--wide skeleton-card">
              <div class="card-inner">
                <div class="card-head">
                  <div class="card-icon-wrap">
                    <mat-icon>monitor_heart</mat-icon>
                  </div>
                  <div class="card-title-area">
                    <div class="card-title">Observations</div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="skeleton-item skeleton-row"></div>
                  <div class="skeleton-item skeleton-row"></div>
                  <div class="skeleton-item skeleton-row"></div>
                </div>
              </div>
            </div>
          } @else if (hasVitalsError) {
            <div class="summary-card vitals-card card--wide empty-card placeholder-card">
              <div class="card-inner">
                <div class="card-head">
                  <div class="card-icon-wrap">
                    <mat-icon>monitor_heart</mat-icon>
                  </div>
                  <div class="card-title-area">
                    <div class="card-title">Observations</div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="empty-state card-error-state">
                    <p>Failed to load observations</p>
                    <button type="button" class="card-retry-btn" (click)="retryVitals()">Retry</button>
                  </div>
                </div>
              </div>
            </div>
          } @else if (vitals.length === 0) {
            <div class="summary-card vitals-card card--wide empty-card placeholder-card">
              <div class="card-inner">
                <div class="card-head">
                  <div class="card-icon-wrap">
                    <mat-icon>monitor_heart</mat-icon>
                  </div>
                  <div class="card-title-area">
                    <div class="card-title">Observations</div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="empty-state">
                    <p>No results found</p>
                  </div>
                </div>
              </div>
            </div>
          } @else {
            <div class="summary-card vitals-card card--wide">
            <div class="card-accent"></div>
            <div class="card-inner">
              <div class="card-head">
                <div class="card-icon-wrap">
                  <mat-icon>monitor_heart</mat-icon>
                </div>
                <div class="card-title-area">
                  <div class="card-title">Observations</div>
                </div>
                <button mat-icon-button class="expand-btn" (click)="openHistoricalDetails('Observations', 'Observations')" aria-label="View all vitals">
                  <mat-icon>open_in_full</mat-icon>
                </button>
              </div>
              <div class="obs-tabs-wrap" [class.obs-tabs-wrap--expanded]="showMoreVitalTabs">
                <div class="obs-tabs-strip">
                  <div class="obs-tabs-primary">
                    @for (group of firstRowVitalTabs; track group.displayName) {
                      <button
                        class="obs-tab"
                        [class.obs-tab--active]="selectedVitalTab === group.displayName"
                        [attr.title]="group.displayName"
                        [attr.aria-label]="group.displayName"
                        (click)="selectVitalTab(group.displayName)">
                        {{ getVitalTabInitials(group.displayName) }}
                      </button>
                    }
                  </div>
                  @if (overflowVitalTabs.length > 0) {
                    <button
                      class="obs-tab obs-tab--more"
                      [class.obs-tab--active]="showMoreVitalTabs"
                      (click)="showMoreVitalTabs = !showMoreVitalTabs">
                      {{ showMoreVitalTabs ? 'Show less' : '+' + overflowVitalTabs.length + ' more' }}
                    </button>
                  }
                </div>
                @if (showMoreVitalTabs) {
                  <div class="obs-tabs-more-list" role="list">
                    @for (group of overflowVitalTabs; track group.displayName) {
                      <button
                        type="button"
                        class="obs-tab obs-tab--more-item"
                        [class.obs-tab--active]="selectedVitalTab === group.displayName"
                        [attr.title]="group.displayName"
                        [attr.aria-label]="group.displayName"
                        (click)="selectVitalTab(group.displayName)">
                        {{ group.displayName }}
                      </button>
                    }
                  </div>
                }
              </div>
              @if (!showMoreVitalTabs) {
                <div class="card-body obs-tab-body">
                  @for (group of groupedVitals; track group.displayName) {
                    @if (selectedVitalTab === group.displayName) {
                      <div class="obs-readings-list">
                        @for (reading of group.readings; track reading.formattedDate) {
                          <div class="obs-reading-row">
                            <span class="obs-reading-date">{{ reading.formattedDate }}</span>
                            <span class="obs-reading-val">{{ reading.value }}</span>
                          </div>
                        }
                      </div>
                    }
                  }
                </div>
              }
            </div>
            </div>
          }

          <!-- Consultation History Card -->
          @if (loadingConsultations) {
            <div class="summary-card consultation-card skeleton-card">
              <div class="card-inner">
                <div class="card-head">
                  <div class="card-icon-wrap">
                    <mat-icon>description</mat-icon>
                  </div>
                  <div class="card-title-area">
                    <div class="card-title">Consultations</div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="skeleton-item skeleton-row"></div>
                  <div class="skeleton-item skeleton-row"></div>
                </div>
              </div>
            </div>
          } @else if (hasConsultationsError) {
            <div class="summary-card consultation-card empty-card placeholder-card">
              <div class="card-inner">
                <div class="card-head">
                  <div class="card-icon-wrap">
                    <mat-icon>description</mat-icon>
                  </div>
                  <div class="card-title-area">
                    <div class="card-title">Consultations</div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="empty-state card-error-state">
                    <p>Failed to load consultations</p>
                    <button type="button" class="card-retry-btn" (click)="retryConsultations()">Retry</button>
                  </div>
                </div>
              </div>
            </div>
          } @else if (consultationHistory.length === 0) {
            <div class="summary-card consultation-card empty-card placeholder-card">
              <div class="card-inner">
                <div class="card-head">
                  <div class="card-icon-wrap">
                    <mat-icon>description</mat-icon>
                  </div>
                  <div class="card-title-area">
                    <div class="card-title">Consultations</div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="empty-state">
                    <p>No results found</p>
                  </div>
                </div>
              </div>
            </div>
          } @else {
          <div class="summary-card consultation-card">
            <div class="card-accent"></div>
            <div class="card-inner">
              <div class="card-head">
                <div class="card-icon-wrap">
                  <mat-icon>description</mat-icon>
                </div>
                <div class="card-title-area">
                  <div class="card-title">Consultations</div>
                </div>
                <button mat-icon-button class="expand-btn" (click)="openHistoricalDetails('Consultations', 'Consultations')" aria-label="View all consultations">
                  <mat-icon>open_in_full</mat-icon>
                </button>
              </div>
              <div class="card-body">
                <div class="consult-list">
                  @for (consultation of consultationHistory; track consultation.uid || $index) {
                    <div class="consult-row" tabindex="0" [class.row-active]="activeConsultationKey === getConsultationKey(consultation)" (click)="showConsultationTooltip(consultation, $event)">
                      <span class="consult-date">{{ consultation.soapNoteDate ? (consultation.soapNoteDate | date:'dd MMM yyyy') : '—' }}</span>
                      <span class="consult-preview" [title]="getConsultationPreview(consultation)">{{ getConsultationPreview(consultation) }}</span>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
          }

          <!-- Conditions Card -->
          @if (loadingConditions) {
            <div class="summary-card conditions-card skeleton-card">
              <div class="card-inner">
                <div class="card-head">
                  <div class="card-icon-wrap">
                    <mat-icon>assignment_turned_in</mat-icon>
                  </div>
                  <div class="card-title-area">
                    <div class="card-title">Classifications</div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="skeleton-item skeleton-row"></div>
                  <div class="skeleton-item skeleton-row"></div>
                  <div class="skeleton-item skeleton-row"></div>
                </div>
              </div>
            </div>
          } @else if (hasConditionsError) {
            <div class="summary-card conditions-card empty-card placeholder-card">
              <div class="card-inner">
                <div class="card-head">
                  <div class="card-icon-wrap">
                    <mat-icon>assignment_turned_in</mat-icon>
                  </div>
                  <div class="card-title-area">
                    <div class="card-title">Classifications</div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="empty-state card-error-state">
                    <p>Failed to load Classifications</p>
                    <button type="button" class="card-retry-btn" (click)="retryConditions()">Retry</button>
                  </div>
                </div>
              </div>
            </div>
          } @else if (conditions.length === 0) {
            <div class="summary-card conditions-card empty-card placeholder-card">
              <div class="card-inner">
                <div class="card-head">
                  <div class="card-icon-wrap">
                    <mat-icon>assignment_turned_in</mat-icon>
                  </div>
                  <div class="card-title-area">
                    <div class="card-title">Classifications</div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="empty-state">
                    <p>No results found</p>
                  </div>
                </div>
              </div>
            </div>
          } @else {
            <div class="summary-card conditions-card" [class.card--wide]="conditions.length > 3">
              <div class="card-accent"></div>
              <div class="card-inner">
                <div class="card-head">
                  <div class="card-icon-wrap">
                    <mat-icon>assignment_turned_in</mat-icon>
                  </div>
                  <div class="card-title-area">
                    <div class="card-title">Classifications</div>
                  </div>
                  <button mat-icon-button class="expand-btn" (click)="openHistoricalDetails('Conditions', 'Classifications')" aria-label="View all conditions">
                    <mat-icon>open_in_full</mat-icon>
                  </button>
                </div>
                <div class="card-body">
                  <div class="condition-list">
                      @for (condition of conditions; track getConditionKey(condition, $index)) {
                        <div class="condition-row" tabindex="0" [class.row-active]="activeConditionKey === getConditionKey(condition, $index)" (click)="showConditionTooltip(condition, $index, $event)">
                          <span class="condition-name" [title]="getConditionName(condition)">{{ getConditionName(condition) }}</span>
                        <span class="condition-status" [ngClass]="getConditionStatus(condition).toLowerCase()">{{ getConditionStatus(condition) }}</span>
                        <span class="condition-date">
                            {{ getConditionDate(condition) }}
                        </span>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          }

          <!-- Medications Card -->
          @if (loadingMedications) {
            <div class="summary-card medications-card skeleton-card">
              <div class="card-inner">
                <div class="card-head">
                  <div class="card-icon-wrap">
                    <mat-icon>medication</mat-icon>
                  </div>
                  <div class="card-title-area">
                    <div class="card-title">Medications</div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="skeleton-item skeleton-row"></div>
                  <div class="skeleton-item skeleton-row"></div>
                  <div class="skeleton-item skeleton-row"></div>
                </div>
              </div>
            </div>
          } @else if (hasMedicationsError) {
            <div class="summary-card medications-card empty-card placeholder-card">
              <div class="card-inner">
                <div class="card-head">
                  <div class="card-icon-wrap">
                    <mat-icon>medication</mat-icon>
                  </div>
                  <div class="card-title-area">
                    <div class="card-title">Medications</div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="empty-state card-error-state">
                    <p>Failed to load medications</p>
                    <button type="button" class="card-retry-btn" (click)="retryMedications()">Retry</button>
                  </div>
                </div>
              </div>
            </div>
          } @else if (medications.length === 0) {
            <div class="summary-card medications-card empty-card placeholder-card">
              <div class="card-inner">
                <div class="card-head">
                  <div class="card-icon-wrap">
                    <mat-icon>medication</mat-icon>
                  </div>
                  <div class="card-title-area">
                    <div class="card-title">Medications</div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="empty-state">
                    <p>No results found</p>
                  </div>
                </div>
              </div>
            </div>
          } @else {
            <div class="summary-card medications-card" [class.card--wide]="medications.length > 3">
            <div class="card-accent"></div>
            <div class="card-inner">
              <div class="card-head">
                <div class="card-icon-wrap">
                  <mat-icon>medication</mat-icon>
                </div>
                <div class="card-title-area">
                  <div class="card-title">Medications</div>
                </div>
                <button mat-icon-button class="expand-btn" (click)="openHistoricalDetails('Medications', 'Medications')" aria-label="View all medications">
                  <mat-icon>open_in_full</mat-icon>
                </button>
              </div>
              <div class="card-body">
                <div class="medication-list">
                  @for (medication of medications; track medication.authoredOn + medication.medicationText + $index) {
                    <div class="medication-row" tabindex="0" [class.row-active]="activeMedicationKey === getMedicationKey(medication)" (click)="showMedicationTooltip(medication, $event)">
                      <span class="medication-name" [title]="formatTooltipValue(medication.medicationText)">{{ formatTooltipValue(medication.medicationText) }}</span>
                      <span class="medication-date">{{ formatTooltipDate(medication.authoredOn) }}</span>
                    </div>
                  }
                </div>
              </div>
            </div>
            </div>
          }

          @if (selectedMedicationDetails) {
                 <div class="tooltip-overlay" tabindex="0" (click)="closeMedicationTooltip()">
              <div class="tooltip-content medication-tooltip"
                   tabindex="0"
                   [ngStyle]="tooltipNgStyle"
                   (click)="$event.stopPropagation()">
                <div class="tooltip-arrow"
                     [ngClass]="{'arrow-up': !tooltipPosition.isAbove}"
                     [ngStyle]="{'left': tooltipPosition.arrowLeft + '%'}"></div>
                <div class="tooltip-header">
                  <h4>{{ formatTooltipValue(selectedMedicationDetails.medicationText) }}</h4>
                  <button mat-icon-button class="close-btn" (click)="closeMedicationTooltip()">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
                <div class="tooltip-body">
                  <div class="tooltip-field">
                    <span class="tooltip-label">Medication:</span>
                    <span class="tooltip-value">{{ formatTooltipValue(selectedMedicationDetails.medicationText) }}</span>
                  </div>
                  <div class="tooltip-field">
                    <span class="tooltip-label">Date:</span>
                    <span class="tooltip-value">{{ formatTooltipDate(selectedMedicationDetails.authoredOn) }}</span>
                  </div>
                  <div class="tooltip-field">
                    <span class="tooltip-label">Route:</span>
                    <span class="tooltip-value">{{ getMedicationRoute(selectedMedicationDetails) }}</span>
                  </div>
                  <div class="tooltip-field">
                    <span class="tooltip-label">Quantity:</span>
                    <span class="tooltip-value">{{ getMedicationQuantity(selectedMedicationDetails) }}</span>
                  </div>
                  <div class="tooltip-field">
                    <span class="tooltip-label">Duration:</span>
                    <span class="tooltip-value">{{ getMedicationDuration(selectedMedicationDetails) }}</span>
                  </div>
                  <div class="tooltip-field">
                    <span class="tooltip-label">Instruction:</span>
                    <span class="tooltip-value">{{ getMedicationInstruction(selectedMedicationDetails) }}</span>
                  </div>
                </div>
              </div>
            </div>
          }

          <!-- Immunizations Card -->
          @if (loadingImmunizations) {
            <div class="summary-card immunizations-card card--wide skeleton-card">
              <div class="card-inner">
                <div class="card-head">
                  <div class="card-icon-wrap">
                    <mat-icon>vaccines</mat-icon>
                  </div>
                  <div class="card-title-area">
                    <div class="card-title">Immunizations</div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="skeleton-item skeleton-row"></div>
                  <div class="skeleton-item skeleton-row"></div>
                  <div class="skeleton-item skeleton-row"></div>
                </div>
              </div>
            </div>
          } @else if (hasImmunizationsError) {
            <div class="summary-card immunizations-card card--wide empty-card placeholder-card">
              <div class="card-inner">
                <div class="card-head">
                  <div class="card-icon-wrap">
                    <mat-icon>vaccines</mat-icon>
                  </div>
                  <div class="card-title-area">
                    <div class="card-title">Immunizations</div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="empty-state card-error-state">
                    <p>Failed to load immunizations</p>
                    <button type="button" class="card-retry-btn" (click)="retryImmunizations()">Retry</button>
                  </div>
                </div>
              </div>
            </div>
          } @else if (immunizations.length === 0) {
            <div class="summary-card immunizations-card card--wide empty-card placeholder-card">
              <div class="card-inner">
                <div class="card-head">
                  <div class="card-icon-wrap">
                    <mat-icon>vaccines</mat-icon>
                  </div>
                  <div class="card-title-area">
                    <div class="card-title">Immunizations</div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="empty-state">
                    <p>No results found</p>
                  </div>
                </div>
              </div>
            </div>
          } @else {
            <div class="summary-card immunizations-card card--wide">
            <div class="card-accent"></div>
            <div class="card-inner">
              <div class="card-head">
                <div class="card-icon-wrap">
                  <mat-icon>vaccines</mat-icon>
                </div>
                <div class="card-title-area">
                  <div class="card-title">Immunizations</div>
                </div>
                <button mat-icon-button class="expand-btn" (click)="openHistoricalDetails('immunization', 'Immunizations')" aria-label="View all immunizations">
                  <mat-icon>open_in_full</mat-icon>
                </button>
              </div>
              <div class="card-body">
                <div class="immun-list">
                  @for (immun of immunizations.slice(0, 5); track immun.uid) {
                      <div class="immun-row" tabindex="0" [class.row-active]="activeImmunizationUid === immun.uid" (click)="showImmunizationTooltip(immun, $event)">
                      <span class="immun-name" [title]="immun.vaccineName || '—'">{{ immun.vaccineName || '—' }}</span>
                      <span class="immun-date">{{ immun.occurrenceDateTime ? (immun.occurrenceDateTime | date:'dd MMM yyyy') : '—' }}</span>
                    </div>
                  }
                  @if (immunizations.length > 5) {
                    <span class="immun-more">+{{ immunizations.length - 5 }} more</span>
                  }
                </div>
              </div>
            </div>
            </div>
          }

          @if (selectedImmunizationDetails) {
                 <div class="tooltip-overlay" tabindex="0" (click)="closeImmunizationTooltip()">
              <div class="tooltip-content immun-tooltip" 
                   tabindex="0"
                   [ngStyle]="tooltipNgStyle"
                   (click)="$event.stopPropagation()">
                <div class="tooltip-arrow" 
                     [ngClass]="{'arrow-up': !tooltipPosition.isAbove}"
                   [ngStyle]="{'left': tooltipPosition.arrowLeft + '%'}"></div>
                <div class="tooltip-header">
                  <h4>{{ formatTooltipValue(selectedImmunizationDetails.vaccineName) }}</h4>
                  <button mat-icon-button class="close-btn" (click)="closeImmunizationTooltip()">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
                <div class="tooltip-body">
                  <div class="tooltip-field">
                    <span class="tooltip-label">Vaccine Name:</span>
                    <span class="tooltip-value">{{ formatTooltipValue(selectedImmunizationDetails.vaccineName) }}</span>
                  </div>
                  <div class="tooltip-field">
                    <span class="tooltip-label">Status:</span>
                    <span class="tooltip-value">{{ formatTooltipValue(selectedImmunizationDetails.status) }}</span>
                  </div>
                  <div class="tooltip-field">
                    <span class="tooltip-label">Occurrence Date:</span>
                    <span class="tooltip-value">{{ selectedImmunizationDetails.occurrenceDateTime ? (selectedImmunizationDetails.occurrenceDateTime | date:'dd MMM yyyy') : '—' }}</span>
                  </div>
                  <div class="tooltip-field">
                    <span class="tooltip-label">Expiry Date:</span>
                    <span class="tooltip-value">{{ selectedImmunizationDetails.expirationDate ? (selectedImmunizationDetails.expirationDate | date:'dd MMM yyyy') : '—' }}</span>
                  </div>
                  <div class="tooltip-field">
                    <span class="tooltip-label">Practitioner:</span>
                    <span class="tooltip-value">{{ formatTooltipValue(selectedImmunizationDetails.practitionerName) }}</span>
                  </div>
                  @if (selectedImmunizationDetails.note) {
                    <div class="tooltip-field">
                      <span class="tooltip-label">Note:</span>
                      <span class="tooltip-value">{{ selectedImmunizationDetails.note }}</span>
                    </div>
                  }
                </div>
              </div>
            </div>
          }

          <!-- Lab Results Card -->
          @if (loadingLabResults) {
            <div class="summary-card lab-results-card skeleton-card">
              <div class="card-inner">
                <div class="card-head">
                  <div class="card-icon-wrap">
                    <mat-icon>biotech</mat-icon>
                  </div>
                  <div class="card-title-area">
                    <div class="card-title">Lab Results</div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="skeleton-item skeleton-row"></div>
                  <div class="skeleton-item skeleton-row"></div>
                </div>
              </div>
            </div>
          } @else if (hasLabResultsError) {
            <div class="summary-card lab-results-card empty-card placeholder-card">
              <div class="card-inner">
                <div class="card-head">
                  <div class="card-icon-wrap">
                    <mat-icon>biotech</mat-icon>
                  </div>
                  <div class="card-title-area">
                    <div class="card-title">Lab Results</div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="empty-state card-error-state">
                    <p>Failed to load lab results</p>
                    <button type="button" class="card-retry-btn" (click)="retryLabResults()">Retry</button>
                  </div>
                </div>
              </div>
            </div>
          } @else if (labResults.length === 0) {
            <div class="summary-card lab-results-card empty-card placeholder-card">
              <div class="card-inner">
                <div class="card-head">
                  <div class="card-icon-wrap">
                    <mat-icon>biotech</mat-icon>
                  </div>
                  <div class="card-title-area">
                    <div class="card-title">Lab Results</div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="empty-state">
                    <p>No results found</p>
                  </div>
                </div>
              </div>
            </div>
          } @else {
          <div class="summary-card lab-results-card">
            <div class="card-accent"></div>
            <div class="card-inner">
              <div class="card-head">
                <div class="card-icon-wrap">
                  <mat-icon>biotech</mat-icon>
                </div>
                <div class="card-title-area">
                  <div class="card-title">Lab Results</div>
                </div>
                <button mat-icon-button class="expand-btn" (click)="openHistoricalDetails('Lab Results', 'Lab Results')" aria-label="View all lab results">
                  <mat-icon>open_in_full</mat-icon>
                </button>
              </div>
              <div class="card-body lab-card-body">
                <div class="lab-list">
                  @for (lab of labResults; track $index) {
                    <div class="lab-row" tabindex="0" [class.row-active]="activeLabResultKey === getLabResultKey(lab)" (click)="showLabResultTooltip(lab, $event)">
                      <span class="lab-name" [title]="formatTooltipValue(lab.displayName)">{{ formatTooltipValue(lab.displayName) }}</span>
                      <span class="lab-date">{{ formatTooltipDate(lab.issuedOn) }}</span>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
          }

          @if (selectedLabResultDetails) {
                 <div class="tooltip-overlay" tabindex="0" (click)="closeLabResultTooltip()">
              <div class="tooltip-content lab-tooltip"
                   tabindex="0"
                   [ngStyle]="tooltipNgStyle"
                   (click)="$event.stopPropagation()">
                <div class="tooltip-arrow"
                     [ngClass]="{'arrow-up': !tooltipPosition.isAbove}"
                     [ngStyle]="{'left': tooltipPosition.arrowLeft + '%'}"></div>
                <div class="tooltip-header">
                  <h4>{{ formatTooltipValue(selectedLabResultDetails.displayName) }}</h4>
                  <button mat-icon-button class="close-btn" (click)="closeLabResultTooltip()">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
                <div class="tooltip-body">
                  <div class="tooltip-field">
                    <span class="tooltip-label">Practitioner:</span>
                    <span class="tooltip-value">{{ formatTooltipValue(selectedLabResultDetails.practitionerName) }}</span>
                  </div>
                  @if (loadingLabResultDetails) {
                    <div class="consultation-tooltip-loading">Loading details...</div>
                  } @else {
                    @if (selectedLabResultEntries.length === 0) {
                      <div class="consultation-tooltip-empty">No results available</div>
                    } @else {
                      @for (entry of selectedLabResultEntries; track $index) {
                        <div class="tooltip-field lab-result-field"
                             [class.lab-result-field--unlabelled]="!entry.label">
                          @if (entry.label) {
                            <span class="tooltip-label">{{ entry.label }}:</span>
                          }
                          <span class="tooltip-value lab-result-value" [innerHTML]="entry.value"></span>
                        </div>
                      }
                    }
                  }
                </div>
              </div>
            </div>
          }
        </div>

        } @else {
        <div class="historical-cards-grid">
          <div class="summary-card allergies-card card--wide empty-card placeholder-card">
            <div class="card-inner">
              <div class="card-head">
                <div class="card-icon-wrap"><mat-icon>warning_amber</mat-icon></div>
                <div class="card-title-area">
                  <div class="card-title">Allergies</div>
                </div>
              </div>
              <div class="card-body">
                <div class="empty-state"><p>No results found</p></div>
              </div>
            </div>
          </div>

          <div class="summary-card vitals-card card--wide empty-card placeholder-card">
            <div class="card-inner">
              <div class="card-head">
                <div class="card-icon-wrap"><mat-icon>monitor_heart</mat-icon></div>
                <div class="card-title-area">
                  <div class="card-title">Observations</div>
                </div>
              </div>
              <div class="card-body">
                <div class="empty-state"><p>No results found</p></div>
              </div>
            </div>
          </div>

          <div class="summary-card consultation-card empty-card placeholder-card">
            <div class="card-inner">
              <div class="card-head">
                <div class="card-icon-wrap"><mat-icon>description</mat-icon></div>
                <div class="card-title-area">
                  <div class="card-title">Consultations</div>
                </div>
              </div>
              <div class="card-body">
                <div class="empty-state"><p>No results found</p></div>
              </div>
            </div>
          </div>

          <div class="summary-card conditions-card empty-card placeholder-card">
            <div class="card-inner">
              <div class="card-head">
                <div class="card-icon-wrap"><mat-icon>assignment_turned_in</mat-icon></div>
                <div class="card-title-area">
                  <div class="card-title">Classifications</div>
                </div>
              </div>
              <div class="card-body">
                <div class="empty-state"><p>No results found</p></div>
              </div>
            </div>
          </div>

          <div class="summary-card medications-card empty-card placeholder-card">
            <div class="card-inner">
              <div class="card-head">
                <div class="card-icon-wrap"><mat-icon>medication</mat-icon></div>
                <div class="card-title-area">
                  <div class="card-title">Medications</div>
                </div>
              </div>
              <div class="card-body">
                <div class="empty-state"><p>No results found</p></div>
              </div>
            </div>
          </div>

          <div class="summary-card immunizations-card card--wide empty-card placeholder-card">
            <div class="card-inner">
              <div class="card-head">
                <div class="card-icon-wrap"><mat-icon>vaccines</mat-icon></div>
                <div class="card-title-area">
                  <div class="card-title">Immunizations</div>
                </div>
              </div>
              <div class="card-body">
                <div class="empty-state"><p>No results found</p></div>
              </div>
            </div>
          </div>

          <div class="summary-card lab-results-card empty-card placeholder-card">
            <div class="card-inner">
              <div class="card-head">
                <div class="card-icon-wrap"><mat-icon>biotech</mat-icon></div>
                <div class="card-title-area">
                  <div class="card-title">Lab Results</div>
                </div>
              </div>
              <div class="card-body">
                <div class="empty-state"><p>No results found</p></div>
              </div>
            </div>
          </div>
        </div>
        }
      </div>

    </div>
  </div>
</div>

@if (selectedConditionDetails) {
  <div class="tooltip-overlay condition-tooltip-overlay" tabindex="0" (click)="closeConditionTooltip()">
    <div class="tooltip-content condition-tooltip"
         role="dialog"
         aria-modal="true"
         aria-labelledby="condition-details-title"
         tabindex="-1"
         [ngStyle]="tooltipNgStyle"
         (click)="$event.stopPropagation()">
      <div class="tooltip-arrow"
           [ngClass]="{'arrow-up': !tooltipPosition.isAbove}"
           [ngStyle]="{'left': tooltipPosition.arrowLeft + '%'}"></div>
      <div class="tooltip-header">
        <h4 id="condition-details-title">{{ getConditionName(selectedConditionDetails) }}</h4>
        <button mat-icon-button class="close-btn" (click)="closeConditionTooltip()" aria-label="Close classification details">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="tooltip-body">
        <div class="tooltip-field">
          <span class="tooltip-label">Classification:</span>
          <span class="tooltip-value">{{ getConditionName(selectedConditionDetails) }}</span>
        </div>
        <div class="tooltip-field">
          <span class="tooltip-label">Status:</span>
          <span class="tooltip-value" [ngClass]="getConditionStatus(selectedConditionDetails).toLowerCase()">{{ getConditionStatus(selectedConditionDetails) }}</span>
        </div>
        <div class="tooltip-field">
          <span class="tooltip-label">Onset Date:</span>
          <span class="tooltip-value">{{ formatTooltipDate(selectedConditionDetails.onsetDateTime) }}</span>
        </div>
        <div class="tooltip-field">
          <span class="tooltip-label">Recorded Date:</span>
          <span class="tooltip-value">{{ formatTooltipDate(selectedConditionDetails.recordedDate) }}</span>
        </div>
      </div>
    </div>
  </div>
}

@if (selectedConsultationDetails) {
  <div class="tooltip-overlay consultation-tooltip-overlay" tabindex="0" (click)="closeConsultationTooltip()">
    <div class="tooltip-content consultation-tooltip"
         role="dialog"
         aria-modal="true"
         aria-labelledby="consultation-details-title"
         tabindex="-1"
         [ngStyle]="consultationTooltipNgStyle"
         (click)="$event.stopPropagation()">
      <div class="tooltip-arrow arrow-right"
           [ngStyle]="{'top': consultationTooltipPosition.arrowTopPx + 'px'}"></div>
      <div class="tooltip-header">
        <h4 id="consultation-details-title">Consultation Details</h4>
        <button mat-icon-button class="close-btn" (click)="closeConsultationTooltip()" aria-label="Close consultation details">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="tooltip-body">
        <div class="consultation-tooltip-date">{{ formatTooltipDate(selectedConsultationDetails.soapNoteDate) }}</div>
        @if (loadingConsultationDetails) {
          <div class="consultation-tooltip-loading">Loading details...</div>
        } @else {
          @if (!selectedConsultationDisplayText) {
            <div class="consultation-tooltip-empty">No details available</div>
          } @else {
            <div class="consultation-soap-note consultation-display-text">{{ selectedConsultationDisplayText }}</div>
          }
        }
      </div>
    </div>
  </div>
}

<ng-template #cdmDialogTemplate>
  <cva-cdm-plan-modal
    [title]="'Chronic Condition Management'"
    [showTitleIcon]="false"
    [showEligibilityLabel]="true"
    [isLoading]="isCdmPlanLoading"
    [errorMessage]="cdmPlanError"
    [rawResponse]="cdmPlanResponse"
    [eligibility]="cdmEligibility"
    [eligibilityReason]="cdmEligibilityReason"
    [annualSmartGoal]="cdmAnnualSmartGoal"
    [planRows]="cdmPlanRows"
    [screeningRows]="cdmHealthScreeningRows"
    [patientName]="getDisplayPatientName()"
    [patientDob]="patientData?.dateOfBirth || ''"
    [patientMrn]="patientData?.medicalRecordNumber || ''"
    [patientGender]="patientData?.gender || ''"
    [patientId]="patientData?.uid || ''">
  </cva-cdm-plan-modal>
</ng-template>

